// extracted by mini-css-extract-plugin
export default {"container":"Project_container__DJOno","projectPage":"Project_projectPage__h24L-"};